import {
    ChangeDetectorRef,
    Component,
    inject,
  } from '@angular/core';
  import { FormsModule } from '@angular/forms';
  
  import { CampaignService } from '../../services/campaign.service';
  
  @Component({
    selector: 'app-public-campaign-form',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './public-campaign-form.html',
    styleUrl: './public-campaign-form.scss',
  })
  export class PublicCampaignForm {
    private campaignService = inject(CampaignService);
    private cdr = inject(ChangeDetectorRef);
  
    isSubmitting = false;
    submitted = false;
  
    responsibleName = '';
    responsibleAge: number | null = null;
    responsibleGender = '';
  
    street = '';
    neighborhood = '';
    municipality = '';
  
    email = '';
    phone = '';
    payment = '';
  
    howDidYouHearAboutAbaq = '';
    socialNetwork = '';
    socialAccount = '';
    recommendedAbaqOnSocialMedia = false;
  
    petName = '';
    species = 'DOG';
    petGender = '';
    breed = '';
    size = '';
    petAge: number | null = null;
    weight: number | null = null;
  
    sterilizationDate = '';
    sterilizationLocation = '';
    campaignType = '';
    veterinarian = '';
    comments = '';
  
    submitForm(): void {
      if (
        !this.responsibleName ||
        !this.petName ||
        !this.species
      ) {
        return;
      }
  
      this.isSubmitting = true;
  
      const campaign = {
        responsibleName: this.responsibleName,
        responsibleAge: this.responsibleAge,
        responsibleGender: this.responsibleGender,
  
        street: this.street,
        neighborhood: this.neighborhood,
        municipality: this.municipality,
  
        email: this.email,
        phone: this.phone,
        payment: this.payment,
  
        howDidYouHearAboutAbaq:
          this.howDidYouHearAboutAbaq,
  
        socialNetwork: this.socialNetwork,
        socialAccount: this.socialAccount,
        recommendedAbaqOnSocialMedia:
          this.recommendedAbaqOnSocialMedia,
  
        petName: this.petName,
        species: this.species,
        petGender: this.petGender,
        breed: this.breed,
        size: this.size,
        petAge: this.petAge,
        weight: this.weight,
  
        sterilizationDate:
          this.sterilizationDate || undefined,
  
        sterilizationLocation:
          this.sterilizationLocation,
  
        campaignType: this.campaignType,
  
        veterinarian: this.veterinarian,
  
        comments: this.comments,
      };
  
      this.campaignService
        .createCampaign(campaign)
        .subscribe({
          next: (response) => {
            console.log(
              '🟢 CAMPAÑA ENVIADA:',
              response,
            );
  
            this.isSubmitting = false;
            this.submitted = true;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR ENVIANDO CAMPAÑA:',
              error,
            );
  
            this.isSubmitting = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  }